<template>
  <div>
    <!-- 多条件筛选区域 -->
    <div
      class="filter-section"
      style="display: flex; flex-wrap: wrap; margin: 0 -7.5px; margin-top: 20px"
    >
      <el-input
        v-model="filters.name"
        placeholder="名称筛选"
        clearable
        style="width: 200px"
      />
      <el-input
        v-model="filters.shippingAddress"
        placeholder="收货地址筛选"
        clearable
        style="margin-left: 20px; width: 200px"
      />

      <el-button type="primary" @click="handleAdd" style="margin-left: 20px">
        新增客户信息
      </el-button>
    </div>

    <!-- 添加加载状态 -->
    <el-alert
      v-if="error"
      title="数据加载失败"
      type="error"
      :description="errorMessage"
      show-icon
      class="error-alert"
    />

    <el-table
      :data="paginatedData"
      border
      style="width: 100%; margin-top: 20px"
      @sort-change="handleSortChange"
      v-loading="loading"
      element-loading-text="数据加载中..."
    ></el-table>

    <!-- 编辑对话框（可与新增共用） -->
    <el-dialog
      :title="isEditMode ? '编辑客户' : '新增客户'"
      :visible.sync="dialogVisible"
      width="500px"
      @closed="handleDialogClose"
    >
      <el-form ref="form" :model="formData" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="formData.name" />
        </el-form-item>
        <el-form-item label="联系方式" prop="contactInfo">
          <el-input v-model="formData.contactInfo" />
        </el-form-item>
        <el-form-item label="收货地址" prop="shippingAddress">
          <el-input v-model="formData.shippingAddress" />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">
          {{ isEditMode ? "保存修改" : "确 定" }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 表格部分 -->
    <el-table
      :data="paginatedData"
      border
      style="width: 100%; margin-top: 20px"
      @sort-change="handleSortChange"
      v-loading="loading"
    >
      <el-table-column prop="name" label="名称" sortable="custom" />
      <el-table-column prop="contactInfo" label="联系方式" sortable="custom" />
      <el-table-column
        prop="shippingAddress"
        label="收货地址"
        sortable="custom"
      />
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页部分 -->
    <el-pagination
      style="margin-top: 20px"
      :current-page="currentPage"
      :page-sizes="[10, 15, 20]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="filteredData.length"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      tableData: [], // 初始为空数组
      loading: false,
      error: false,
      errorMessage: "",
      filters: {
        name: "",
        shippingAddress: "",
      },
      currentPage: 1,
      pageSize: 10,
      sortProp: "",
      sortOrder: "",
      // 新增相关状态
      dialogVisible: false,
      submitting: false,
      formData: {
        objectId: "",
        name: "",
        contactInfo: "",
        shippingAddress: "",
      },
      isEditMode: false,
    };
  },

  created() {
    this.fetchData();
  },

  computed: {
    filteredData() {
      return this.tableData.filter((item) => {
        // 名称筛选
        const nameMatch = item.name.includes(this.filters.name);

        // 地址筛选
        const addressMatch = item.shippingAddress.includes(
          this.filters.shippingAddress
        );

        return nameMatch && addressMatch;
      });
    },

    // 处理排序后的数据
    sortedData() {
      if (!this.sortProp) return this.filteredData;

      return [...this.filteredData].sort((a, b) => {
        const valA = a[this.sortProp];
        const valB = b[this.sortProp];

        if (this.sortOrder === "ascending") {
          return valA > valB ? 1 : -1;
        }
        return valA > valB ? -1 : 1;
      });
    },

    // 分页后的数据
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.sortedData.slice(start, end);
    },
  },

  methods: {
    //数据加载
    async fetchData() {
      this.loading = true;
      this.error = false;

      try {
        const response = await axios.get("/api/Customer/getAllCustomer");

        this.tableData = response.data.result;
      } catch (error) {
        this.error = true;
        this.errorMessage = error.message || "未知错误";
        console.error("数据加载失败:", error);
      } finally {
        this.loading = false;
      }
    },

    // 打开新增对话框
    handleAdd() {
      this.dialogVisible = true;
    },

    // 编辑按钮点击处理
    handleEdit(index, row) {
      this.isEditMode = true;
      this.formData = { ...row }; // 浅拷贝行数据
      this.dialogVisible = true;
    },

    // 提交表单
    async handleSubmit() {
      try {
        this.submitting = true;

        var response = null;
        if (this.isEditMode) {
          // 调用更新接口
          response = await axios.post(
            "/api/Customer/editCustomer",
            this.formData
          );
        } else {
          // 调用新增接口
          response = await axios.post(
            "/api/Customer/addCustomer",
            this.formData
          );
        }

        // 根据接口返回处理
        if (response.data.result.code == 200) {
          this.$message.success("操作成功");

          await this.fetchData();

          this.dialogVisible = false;
        } else {
          this.$message.error(`操作失败: ${response.data.result.message}`);
        }
      } catch (error) {
        this.$message.error(`操作失败: ${error.message}`);
      } finally {
        this.submitting = false;
      }
    },

    // 对话框关闭时重置表单
    handleDialogClose() {
      this.isEditMode = false;
      this.$refs.form.resetFields();
    },

    // 分页大小变化
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
    },

    // 当前页变化
    handleCurrentChange(val) {
      this.currentPage = val;
    },

    // 排序变化
    handleSortChange({ prop, order }) {
      this.sortProp = prop;
      this.sortOrder = order;
      this.currentPage = 1;
    },
  },
};
</script>

<style scoped>
.filter-section {
  margin-bottom: 20px;
}

.el-col {
  margin-bottom: 10px;
}

.error-alert {
  margin-bottom: 20px;
}
</style>